function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#center_svg__clip0_1_31)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.053 14.92c-3.82 0-6.916-3.066-6.916-6.85 0-3.782 3.096-6.849 6.916-6.849 3.817 0 6.914 3.066 6.914 6.849 0 3.784-3.096 6.85-6.914 6.85zm0-1.68c-2.891 0-5.236-2.322-5.236-5.185 0-2.866 2.345-5.187 5.236-5.187 2.89 0 5.235 2.322 5.235 5.185 0 2.865-2.345 5.185-5.235 5.185v.002z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.885 8.07a2.826 2.826 0 01-2.832 2.818A2.825 2.825 0 015.22 8.072V8.07a2.824 2.824 0 012.832-2.818 2.826 2.826 0 012.832 2.818zM13 7.142h2.747c.17 0 .305.203.305.451v.956c0 .248-.136.45-.306.45H13c-.168 0-.306-.202-.306-.45v-.956c0-.248.138-.45.306-.45zm-9.896 0c.168 0 .306.203.306.451v.956c0 .248-.138.45-.306.45H.359c-.17 0-.306-.202-.306-.45v-.956c0-.248.136-.45.306-.45h2.746zM8.975.37l.032 2.721a.306.306 0 01-.302.308l-1.264.013a.306.306 0 01-.31-.3L7.097.391c0-.168.136-.304.303-.307L8.664.07a.305.305 0 01.31.3zm.007 12.712l.02 2.622c.002.195-.136.354-.304.355l-1.264.011c-.17 0-.308-.155-.31-.349l-.02-2.623c-.003-.194.135-.354.303-.356l1.264-.01c.17-.001.308.155.31.35z"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "center_svg__clip0_1_31"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})));

function SvgCenter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgCenter;